import React, { useState, useEffect } from 'react';
import { Select, Spin } from 'antd'; // Import Spin for loading indicator
import taskReminderService from '../../services/taskReminder';

export default function ReminderGroupComponent({ onChange, value, all }) {

  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Add error state

  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const response = all
          ? await taskReminderService.getGroups()
          : await taskReminderService.getGroups();
        const groupsData = Array.isArray(response.data) ? response.data : [];

        setGroups(groupsData);
      } catch (err) {
        console.error("Error fetching groups:", err);
        setError(err); // Set the error state
      } finally {
        setLoading(false);
      }
    };

    fetchGroups();
  }, [all]); // Add 'all' to the dependency array


  if (loading) {
    return <Spin />; // Display loading indicator
  }

  if (error) {
    return <div>Error: {error.message}</div>; // Display error message
  }


  return (
    <Select
      showSearch
      optionFilterProp="children"
      style={{ width: '100%' }}
      size="large"
      placeholder="Please Select Department"
      value={groups.length ? value ?? undefined : undefined}
      onChange={onChange}
      allowClear
      notFoundContent={groups.length === 0 ? "No groups found" : null} // Handle empty state
    >
      {groups.map((grp) => (
        <Select.Option key={grp.id} value={grp.id}>
          {grp.name}
        </Select.Option>
      ))}
    </Select>
  );
}